// pubg game lang
export const langMap = [
  {"code":"en","name":"English", "lang": "en_US"},
  {"code":"ru","name":"Pусский", "lang": "ru_RU"},
  {"code":"pt","name":"Português(BR)", "lang": "pt_PT"},
  {"code":"th","name":"ไทย", "lang": "th_TH"},
  {"code":"zh","name":"简体中文", "lang": "zh_CN"},
  {"code":"HK","name":"繁體中文(香港)", "lang": "HK"},
  {"code":"TW","name":"繁體中文(台湾)", "lang": "TW"},
  {"code":"de","name":"Deutsch", "lang": "de_DE"},
  {"code":"id","name":"Bahasa Indonesia", "lang": "in_ID"},
  {"code":"fr","name":"Français", "lang": "fr_FR"},
  {"code":"es","name":"Español(Latam)", "lang": "es_ES"},
  {"code":"tr","name":"Türkçe", "lang": "tr_TR"},
  {"code":"ar","name":"العربية", "lang": "ar_SA"},
  {"code":"ms","name":"Bahasa Melayu", "lang": "ms_MY"},
  {"code":"vi","name":"Tiếng Việt", "lang": "vi_VN"},
  {"code":"hi","name":"हिन्दी", "lang": "hi_IN"},
  {"code":"ko","name":"한국어", "lang": "ko_KR"},
  {"code":"ja","name":"Japan", "lang": "ja_JP"}
];
